import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import Icon from '../components/ui/Icons';
import { ROUTES } from '../config/company';

export default function NotFound() {
  return (
    <>
      <PageHero eyebrow="404" title="That page rolled off the lot." lede="The address you followed does not exist on this site. Head back home or jump straight to our trailers." compact>
        <div className="flex flex-wrap gap-3">
          <Link to={ROUTES.home} className="btn-primary">Back to home <Icon name="arrowRight" className="h-4 w-4" /></Link>
          <Link to={ROUTES.trailers} className="btn-outline-light">View trailers</Link>
        </div>
      </PageHero>
      <div className="h-16" />
    </>
  );
}
